import { render, staticRenderFns } from "./keyMetrics.vue?vue&type=template&id=212afe2c&scoped=true&"
import script from "./keyMetrics.vue?vue&type=script&lang=js&"
export * from "./keyMetrics.vue?vue&type=script&lang=js&"
import style0 from "./keyMetrics.vue?vue&type=style&index=0&id=212afe2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212afe2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
